<template>
  <v-layout>
    <v-flex sm9>
      <div>
        <v-chip
          label
          v-if="empleo.orden == 1"
          color="primary"
          text-color="white"
          >Primaria</v-chip
        >
        <v-chip
          label
          v-if="empleo.orden == 2"
          color="secondary"
          text-color="white"
          >Secundaria</v-chip
        >
        <v-chip label outlined v-if="empleo.orden == 3" color="secondary"
          >Terciaria</v-chip
        >

        {{
          empleo.situacionLaboralId == 1 || empleo.situacionLaboralId == 5
            ? "Trabaja en  " + empleo.empleador
            : ""
        }}
        {{
          empleo.situacionLaboralId == 2 || empleo.situacionLaboralId == 3
            ? "Es " + empleo.situacionLaboralDescripcion
            : ""
        }}
        {{
          empleo.situacionLaboralId == 4
            ? "Es " + empleo.situacionLaboralDescripcion
            : ""
        }}
        {{
          empleo.situacionLaboralId == 6
            ? "Es " + empleo.situacionLaboralActividadDescripcion
            : ""
        }}
      </div>
    </v-flex>
    <!-- {{ empleo }} -->
    <v-spacer></v-spacer>
    <v-flex sm1>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="editar" :disabled="!canUpdate">
            <v-icon color="red lighten-2">edit</v-icon></v-btn
          >
        </template>
        <span>Editar</span>
      </v-tooltip>
    </v-flex>
    <v-flex sm1>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="eliminar">
            <v-icon color="grey">delete</v-icon></v-btn
          >
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </v-flex>

    <v-dialog v-model="editModeOn" persistent width="1000">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline" primary-title
          >Edición de Actividad
          {{ empleo.orden == 1 ? " Principal" : "" }}</v-card-title
        >

        <app-empleo-editor
          :empleo="empleo"
          :empleos="empleos"
          :visible="editModeOn"
          modo="full"
          ref="editorControl">
        </app-empleo-editor>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="accent" text @click="editModeOn = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmarModificacion()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  data: () => ({
    editModeOn: false,
    loading: false,
    empleo: {},
    //empleoEditor: {orden: 1, situacionLaboralId: 1, descripcion: '', fechaIngreso: '1900-01-01'}, // hay que poner valores default porque si no no toma los cambios de forma dinámica
    valid: false,
    listActividadesLaborales: [],
    listSituacionesLaborales: [],
    listSubSituacionesLaborales: [],
    listOrdenEmpleo: [
      { id: 1, descripcion: "Principal" },
      { id: 2, descripcion: "Secundaria" },
      { id: 3, descripcion: "Terciaria" },
    ],
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    empleos: {
      type: Array,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      default: "empleo",
    },
    iconName: {
      type: String,
      default: "home",
    },
    editMode: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    "value.telefono": function () {
      this.setTelefono();
    },
  },
  computed: {
    ...mapGetters(["checkCanUpdate"]),
    canUpdate: function () {
      return this.checkCanUpdate("ap-puede-modificar-empleadores");
    },
    listSituacionesLaboralesActividades: function () {
      if (this.empleo) {
        for (
          let index = 0;
          index < this.listSituacionesLaborales.length;
          index++
        ) {
          if (
            this.listSituacionesLaborales[index].id ==
            this.empleo.situacionLaboralId
          ) {
            // si es un nuevo registro, solo muestro las actividades no anuladas

            var esNuevo =
              this.empleo.id == "00000000-0000-0000-0000-000000000000";

            return this.listSituacionesLaborales[index].actividades.filter(
              function (item) {
                return !item.anulado || !esNuevo;
              },
            );
          }
        }
      }
      return [];
    },
  },
  created() {
    // todo: cargar Pertenece A
    this.loadActividadesLaborales();
    this.loadSituacionesLaborales();
    this.loadSubSituacionesLaborales();
    // cargo el modelo
    this.setEmpleo();
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    setEmpleo() {
      if (this.propName == "") {
        this.empleo = this.value;
        //this.copiarEmpleo(this.value, this.empleoEditor); // hago una copia del empleo para poder modificarlo si afeectar al original
      } else {
        if (!this.value[this.propName]) {
          // Si el telefono no está cargado, creo la propiedad
          this.telefono = {};

          this.value[this.propName] = this.telefono;
        }
        this.telefono = this.value[this.propName];
      }
    },
    copiarEmpleo(source, destination) {
      destination.orden = source.orden;
      destination.id = source.id;
      destination.cui = source.cui;
      destination.empleador = source.empleador;
      destination.email = source.email;
      destination.fechaIngreso = this.$moment(source.fechaIngreso).format(
        "YYYY-MM-DD",
      );
      destination.actividadLaboralId = source.actividadLaboralId;
      destination.diaCobroId = source.diaCobroId;
      destination.formaCobroId = source.formaCobroId;
      destination.cargo = source.cargo;
      destination.seccion = source.seccion;
      destination.jefe = source.jefe;
      destination.horario = source.horario;
      destination.ingresoNeto = source.ingresoNeto;
      destination.patrimonioNetoDdjj = source.patrimonioNetoDdjj;
      destination.resultadoNetoDdjj = source.resultadoNetoDdjj;
      destination.situacionLaboralId = source.situacionLaboralId;
      destination.situacionLaboralActividadId =
        source.situacionLaboralActividadId;
      destination.categoriaMonotributo = source.categoriaMonotributo;
      destination.descripcion = source.descripcion;
      destination.domicilios = source.domicilios;
      destination.telefonos = source.telefonos;
      destination.situacionLaboralDescripcion =
        source.situacionLaboralDescripcion;
      destination.situacionLaboralActividadDescripcion =
        source.situacionLaboralActividadDescripcion;
      // destination.subSituacionLaboralId = source.subSituacionLaboralId;
    },
    eliminar() {
      this.$parent.$parent.$parent.$parent.deleteChild(this.empleo); // cuando está dentro de una lista hay toda una jerarquía...
    },
    editar() {
      //this.copiarEmpleo(this.empleo, this.empleoEditor);
      //Vue.$log.error(this.empleoEditor);
      this.editModeOn = true;
    },
    async confirmarModificacion() {
      // valido

      var result = await this.$refs.editorControl.validar();
      if (!result) return;

      // valido que el empleador esté cargado
      if (!this.empleo.empleador || this.empleo.empleador.trim() == "") {
        this.alertWarning("Debe buscar y seleccionar un empleador válido.");
        return;
      }

      // agrego la descripcion de las situaciones
      var situacionLaboralId = this.empleo.situacionLaboralId;
      this.empleo.situacionLaboralDescripcion =
        this.listSituacionesLaborales.filter(function (item) {
          return item.id == situacionLaboralId;
        })[0].descripcion;

      var situacionLaboralActividadId = this.empleo.situacionLaboralActividadId;
      this.empleo.situacionLaboralActividadDescripcion =
        this.listSituacionesLaboralesActividades.filter(function (item) {
          return item.id == situacionLaboralActividadId;
        })[0].descripcion;

      //this.copiarEmpleo(this.empleoEditor, this.empleo);
      this.value = this.empleo;

      this.editModeOn = false;
    },
    async loadActividadesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposactividadlaboral"); // traigo todas
        this.listActividadesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales/listarparaingreso"); // traigo todas
        this.listSituacionesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSubSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposSubSituacionLaboral"); // traigo todas
        this.listSubSituacionesLaborales = result.list;

        //this.setHintSituacionLaboral();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
